// extracted by mini-css-extract-plugin
module.exports = {"container":"_9400a595a7--container--UMBqb","text":"_9400a595a7--text--RPKvz"};